import { render } from "./CustomersView.vue?vue&type=template&id=15195423&scoped=true"
import script from "./CustomersView.vue?vue&type=script&lang=js"
export * from "./CustomersView.vue?vue&type=script&lang=js"

import "./CustomersView.vue?vue&type=style&index=0&id=15195423&scoped=true&lang=css"

import exportComponent from "/Users/chrisfinlayson/Desktop/WORK/riverhawk-nest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15195423"]])

export default __exports__